const formatDateToLocaleTimeString = (date: Date) => {
    return date.toLocaleString() + ' Uhr'
}

export { formatDateToLocaleTimeString }
